<div class="!grid !grid-cols-1 !gap-5 lg:!grid-cols-2" role="status" aria-live="polite" aria-label="Caricamento dati società">
    <section class="!flex !gap-4 !rounded-2xl !border !border-solid !border-border !bg-white !p-5 sm:!p-6 lg:!col-span-2">
        <div class="!h-16 !w-16 !shrink-0 !animate-pulse !rounded-2xl !bg-slate-200 sm:!h-20 sm:!w-20"></div>
        <div class="!flex !min-w-0 !flex-1 !flex-col !justify-center !gap-2">
            <div class="!h-6 !w-48 !max-w-[70%] !animate-pulse !rounded !bg-slate-200"></div>
            <div class="!h-4 !w-72 !max-w-full !animate-pulse !rounded !bg-slate-200"></div>
        </div>
    </section>
    <section *ngFor="let card of cardPlaceholders"
             class="!rounded-2xl !border !border-solid !border-border !bg-white !p-6 md:!p-8">
        <div class="!mb-5 !border-b !border-solid !border-slate-100 !pb-3">
            <div class="!h-5 !w-40 !animate-pulse !rounded !bg-slate-200"></div>
            <div class="!mt-2 !h-3 !w-56 !max-w-full !animate-pulse !rounded !bg-slate-200"></div>
        </div>
        <div class="!grid !grid-cols-1 !gap-5 sm:!grid-cols-2">
            <div *ngFor="let field of fieldPlaceholders" class="!flex !flex-col !gap-2">
                <div class="!h-3 !w-24 !animate-pulse !rounded !bg-slate-200"></div>
                <div class="!h-11 !w-full !animate-pulse !rounded-xl !bg-slate-100"></div>
            </div>
        </div>
    </section>
    <span class="visually-hidden">Caricamento in corso</span>
</div>
